// Marca (logo, nombre y colores) de la empresa que usa esta instalación.
// Se define con variables de entorno (ver .env.telusgy.example). Si REACT_APP_MARCA está vacía se usa la marca
// de siempre (TRS): los logos que ya están dentro de src/assets y los colores del tema.
//
// Cada marca vive en public/marcas/<REACT_APP_MARCA>/ con estos archivos:
//   logo.png        nombre completo para fondos claros
//   logo_blanco.png nombre completo para barras / fondos oscuros
//   icono.png       ícono cuadrado (pantalla de carga)
//   favicon.ico, logo192.png, logo512.png, manifest.json   (pestaña del navegador y app instalable)
const id = process.env.REACT_APP_MARCA || "";
const base = id ? `${process.env.PUBLIC_URL || ""}/marcas/${id}` : "";

const MARCA = {
  id,
  nombre: process.env.REACT_APP_EMPRESA_NOMBRE || "",
  colorPrimario: process.env.REACT_APP_COLOR_PRIMARIO || "#005d64",
  colorSecundario: process.env.REACT_APP_COLOR_SECUNDARIO || "#6366F1",
  // Alto (px) del logo en la barra superior. Un logo ancho como el de Telusgy se ve mejor más bajo.
  altoLogoBarra: Number(process.env.REACT_APP_LOGO_ALTO) || 40,
  // null = el componente usa el logo que trae empacado (TRS)
  logo: base ? `${base}/logo.png` : null,
  logoBlanco: base ? `${base}/logo_blanco.png` : null,
  icono: base ? `${base}/icono.png` : null,
  favicon: base ? `${base}/favicon.ico` : null,
  icono192: base ? `${base}/logo192.png` : null,
  manifest: base ? `${base}/manifest.json` : null,
};

const ponerAtributo = (selector, atributo, valor) => {
  const el = document.querySelector(selector);
  if (el && valor) el.setAttribute(atributo, valor);
};

// Cambia en el navegador lo que index.html trae fijo: título, color de la barra del móvil, ícono y manifest.
export const aplicarMarca = () => {
  if (typeof document === "undefined" || !id) return;
  if (MARCA.nombre) document.title = MARCA.nombre;
  ponerAtributo('meta[name="theme-color"]', "content", MARCA.colorPrimario);
  ponerAtributo('link[rel="icon"]', "href", MARCA.favicon);
  ponerAtributo('link[rel="apple-touch-icon"]', "href", MARCA.icono192);
  ponerAtributo('link[rel="manifest"]', "href", MARCA.manifest);
};

export default MARCA;
